var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",staticClass:"form-container",attrs:{"sandbox":"allow-forms allow-scripts allow-modals allow-popups allow-same-origin allow-top-navigation","src":_vm.url}})}
var staticRenderFns = []

export { render, staticRenderFns }